var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 32,
  height: 32,
  viewBox: "0.032 2.145 32 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.885 2.145h4.161v27.71h-4.161z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M26.356 2.145V3.53H5.574V2.145zM29.129 25.699l2.77 4.155H.032L2.8 25.699zM11.116 20.157v1.387H.032v-1.387zM31.898 20.157v1.387H20.814v-1.387z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.116 18.771v2.773L5.534 6.305.032 21.544v-2.773l5.52-15.24zM31.898 18.771v2.773L26.322 6.305l-5.508 15.239v-2.773l5.524-15.24z",
  clipRule: "evenodd"
})));
export default SvgScale;